
import template from './charts-list.html';

/**
 * Charts List VM
 */
class ChartsListPageViewModel
{
	constructor(page)
	{
		this.page = page;
		this.element = page.element;

		this.charts_data = ko.observableArray([]);
		this.no_data = ko.observable(false);
	}

	async load ()
	{
		let data = await Grape.fetches.getJSON('/api/record', {schema: 'echarts', table: 'v_charts'});
		if (data.status === 'OK' && data.records.length > 0)
		{
			let process = data.records.map(rec => {
				return {
					chart_id: rec.chart_id,
					chart_name: rec.name
				}
			});
			this.charts_data(process);
			this.no_data(false);
		}
		else
			this.no_data(true);
	}

	async add_chart (data)
	{
		let response = await Grape.dialog.open('Chart', {chart: ''});
		if (response)
			this.load();
	}

	async delete_chart (data)
	{
		let response = await Grape.fetches.postJSON('/api/echarts/chart/delete', {chart_id: data});
		if (response)
			this.load();
	}

	view_chart (data)
	{
		Grape.BreadCrumb.push({ name: data.chart_name, route: `/charts/chart-view/${String(data.chart_name)}` });
	}
}

/**
 * page class
 */
class ChartsListPageClass
{
	constructor(bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ChartsListPageViewModel(this);
	}

	async init()
	{
		document.title = 'Chart List';
		Grape.BreadCrumb.push({ default_route: { 'Home': '/ui/landing','Setup': '/ui/crm/setup-page', 'Charts': '/ui/charts/charts-list' } });
		await this.viewModel.load();
	}

	async teardown() {}
}

export default {
	route: '[/]ui/charts/charts-list',
	page_id: '[/]ui/charts/charts-list',
	page_class: ChartsListPageClass,
	template: template,
	title: 'Charts',
	icon: 'fa fa-file-chart-pie',
	idx: 10
}
